module.exports = __webpack_public_path__ + "static/media/main_background.51810c27.mp3";